import { QrresultPage } from "./../qrresult/qrresult";
import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-plaza-scan-pay",
  templateUrl: "plaza-scan-pay.html",
})
export class PlazaScanPayPage {
  scanSub: any;
  theme = 1;
  constructor(
    public navCtrl: NavController,
    private qrScanner: QRScanner,
    private loadingCtrl: LoadingController,
    private storage: Storage
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.qrScanner
      .prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          // console.log('Camera Permission Given');
          this.scanSub = this.qrScanner.scan().subscribe((text: string) => {
            //  console.log('Scanned something', text);

            let loader = this.loadingCtrl.create({
              // content: "Loading Please Wait...",
              duration: 1000,
            });
            loader.present();

            this.navCtrl.push(QrresultPage, { text });

            this.qrScanner.hide();
            this.scanSub.unsubscribe();
          });

          this.qrScanner.show();
        } else if (status.denied) {
          console.log("Camera permission denied");
        } else {
          console.log("Permission denied for this runtime.");
        }
      })
      .catch((e: any) => console.log("Error is", e));
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-scan-pay/plaza-scan-pay.ts